import { Drawer, Input, Col, Form, Select, Row, Button, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { updateApp } from '../../../services/client';
import { useState, useEffect } from 'react';
import './EditAppDrawerForm.css';
import { successNotification, errorNotification } from '../../../utils/Notification';

const { Option } = Select;

const antIcon = <LoadingOutlined spin />;

function EditAppDrawerForm({ showEditDrawer, closeEditDrawer, app, fetchApps }) {
    const [form] = Form.useForm();
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (app) {
            Object.keys(app).forEach(key => {
                form.setFieldsValue({ [key]: app[key] });
            });
        }
    }, [app, form]);


    const onFinish = values => {
        setSubmitting(true);
        updateApp(app.appId, values)
            .then(() => {
                console.log("App Updated");
                closeEditDrawer();
                successNotification("App was successfully Updated", `${values.name} was updated in the system`);
                fetchApps();
                form.resetFields();
            }).catch(err => {
                errorNotification(err, null);
            }).finally(() => {
                setSubmitting(false);
            });
    };

    const onFinishFailed = errorInfo => {
        errorNotification(errorInfo, null);
    };

    const handleDrawerClose = () => {
        closeEditDrawer();
    };

    return (
        <Drawer
            title="Edit App Data"
            width={720}
            onClose={handleDrawerClose}
            visible={showEditDrawer}
            styles={{ body: { paddingBottom: 80 } }}
            footer={
                <div
                    style={{
                        textAlign: 'right',
                    }}
                >
                    <Button onClick={handleDrawerClose} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                </div>
            }
        >
            <Form
                form={form} // Pass the form instance to the Form component
                layout="vertical"
                onFinishFailed={onFinishFailed}
                onFinish={onFinish}
                initialValues={app}
                requiredMark
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="logo"
                            label="Logo"
                            rules={[{ required: true, message: "Please enter the logo's address" }]}
                        >
                            <Input placeholder="Please enter the logo's address" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="name"
                            label="Name"
                            rules={[{ required: true, message: "Please enter the app's name" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="description"
                            label="Description"
                            rules={[{ required: true, message: "Please enter the App's description" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="containerPort"
                            label="Container Port"
                            rules={[{ required: true, message: "Please enter the container port" }]}
                        >
                            <Input placeholder="Please enter the container port" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="dockerPort"
                            label="Docker Port"
                            rules={[{ required: true, message: "Please enter the docker port" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="website"
                            label="Website"
                            rules={[{ required: true, message: "Please enter the website  address" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="githubRepo"
                            label="Github"
                            rules={[{ required: true, message: "Please enter github's repo address" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="hostPlatform"
                            label="Host Platform"
                            rules={[{ required: true, message: 'Please select a host platform' }]}
                        >
                            <Select>
                                <Option value="GITHUB">GITHUB</Option>
                                <Option value="DIGITAL_OCEAN">DIGITAL_OCEAN</Option>
                                <Option value="LOCAL">LOCAL</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Form.Item >
                            <Button type="primary" htmlType="submit">
                                Update
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    {submitting && <Spin indicator={antIcon} />}
                </Row>
            </Form>
        </Drawer>
    );
}

export default EditAppDrawerForm;